const modules = [
  {
    title: 'Módulo 1 — Coletor de Editais',
    icon: 'ri-radar-line',
    phase: 'Mês 1',
    items: [
      'Monitoramento automático de todas as chamadas públicas FINEP a cada 6 horas',
      'Detecção de novos editais e alterações em editais já publicados',
      'Download automático de PDFs vinculados às chamadas',
      'Extração estruturada de texto incluindo documentos digitalizados',
      'Gerenciamento de fila persistente com sobrevivência a reinicializações',
      'Cadastro manual de PDFs externos pelo gestor da plataforma',
    ],
  },
  {
    title: 'Módulo 2 — Agente Analisador',
    icon: 'ri-brain-line',
    phase: 'Mês 1 a 2',
    highlight: true,
    items: [
      'Extração automática de 8 categorias por edital: elegibilidade, escopo, orçamento, equipe, critérios, prazos, documentos e restrições',
      'Análise completa mesmo de editais extensos com centenas de páginas',
      'Alertas automáticos de prazo: D-30, D-15, D-7 e D-1',
      'Validação de consistência e reprocessamento automático em caso de falha',
      'Notificações por e-mail e painel com resumo executivo por edital',
    ],
  },
  {
    title: 'Módulo 3 — Portfólio e Matching',
    icon: 'ri-links-line',
    phase: 'Mês 2',
    items: [
      'Cadastro de projetos do instituto via formulário web ou importação de planilha',
      'Pontuação de 0 a 100 para cada par projeto x edital em 6 dimensões',
      'Ranking automático de editais mais aderentes para cada projeto',
      'Justificativa textual gerada automaticamente explicando a pontuação',
      'Sinalização visual de incompatibilidades que tornam a candidatura inviável',
    ],
  },
  {
    title: 'Módulo 4 — Dashboard e Gestão',
    icon: 'ri-dashboard-line',
    phase: 'Mês 2',
    items: [
      'Painel principal com todos os editais FINEP ativos, prazo, valor e pontuação',
      'Filtros por área temática, nível tecnológico, faixa de valor e pontuação mínima',
      'Mapa de oportunidades mostrando todos os pares projeto x edital ranqueados',
      'Pipeline Kanban com etapas: Ignorar, Monitorar, Em Proposta, Submetido e Resultado',
      'Monitor de prazos com barras de progresso, indicadores de urgência e contagem regressiva',
    ],
  },
  {
    title: 'Módulo 5 — Base de Conhecimento',
    icon: 'ri-book-open-line',
    phase: 'Mês 2 a 3',
    items: [
      'Ingestão e indexação do Manual do Proponente FINEP e seus anexos',
      'Carregamento de propostas aprovadas em chamadas anteriores como referência',
      'Inclusão da legislação de Ciência, Tecnologia e Inovação vigente',
      'Glossários técnicos por área de atuação: TIC, saúde, energia, agro e biotech',
      'Busca semântica que encontra os trechos mais relevantes para cada seção a ser gerada',
    ],
  },
  {
    title: 'Módulo 6 — Agente Escritor',
    icon: 'ri-quill-pen-line',
    phase: 'Mês 3',
    highlight: true,
    items: [
      'Geração automática das 10 seções obrigatórias de uma proposta FINEP com linguagem técnica e objetiva',
      'Arquitetura multi-agente: orquestrador central coordena agentes especializados por seção',
      'Ciclo de autocrítica interno (self-critique loop) que avalia e reescreve até atingir qualidade mínima aceitável',
      'RAG consultando a base de conhecimento em tempo real durante a escrita',
      'Adequação automática ao vocabulário, critérios e linguagem específicos de cada edital',
      'Visualização do texto sendo gerado em tempo real seção por seção',
      'Sessões de calibração com o setor de editais do instituto para ajuste fino do agente',
    ],
  },
  {
    title: 'Módulo 7 — Exportação e Conformidade',
    icon: 'ri-file-download-line',
    phase: 'Mês 3',
    items: [
      'Exportação da proposta em formato compatível com o padrão de submissão FINEP',
      'Checklist automático de conformidade com percentual de aderência, lacunas identificadas e sugestões de correção',
      'Versionamento completo de propostas com histórico de alterações e possibilidade de restaurar versões anteriores',
      'Exportação em PDF formatado pronto para apresentação ao comitê avaliador',
    ],
  },
  {
    title: 'Módulo 8 — Editor e Monitoramento',
    icon: 'ri-edit-2-line',
    phase: 'Mês 3 a 4',
    items: [
      'Editor de texto integrado com visualização em tempo real, salvamento automático e destaque de trechos gerados por IA',
      'Painel de saúde dos serviços internos da plataforma com alertas de falha',
      'Monitoramento visual do processamento de filas em execução',
      'Alertas automáticos quando a taxa de erros ou a qualidade das análises cai abaixo do limite aceitável',
    ],
  },
];

export default function MvpTecnica() {
  return (
    <section id="tecnica" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">II</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte II</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Proposta Técnica — Fase 1</h2>
        <p className="text-stone-500 mb-4 text-base">Escopo completo da Versão 1 — 8 módulos entregues ao longo de 4 meses.</p>

        {/* Phase header */}
        <div className="p-5 rounded-xl border border-emerald-200 bg-emerald-50 mb-10">
          <div className="flex flex-wrap items-center gap-3 mb-2">
            <span className="px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold">Versão 1</span>
            <span className="px-3 py-1 rounded-full bg-stone-100 text-stone-600 text-xs font-medium">4 meses</span>
            <span className="px-3 py-1 rounded-full bg-stone-100 text-stone-600 text-xs font-medium">90 dias de desenvolvimento</span>
            <span className="px-3 py-1 rounded-full bg-stone-100 text-stone-600 text-xs font-medium">30 dias de ajustes e testes finais</span>
          </div>
          <p className="text-stone-600 text-sm leading-relaxed">
            Ciclo completo end-to-end: do monitoramento automático de editais até a geração e exportação de propostas prontas para submissão ao FINEP. A plataforma é funcional e utilizável ao final desta versão, com todos os módulos integrados e testados.
          </p>
        </div>

        {/* Modules grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {modules.map((mod) => (
            <div
              key={mod.title}
              className={`p-5 rounded-xl border ${mod.highlight ? 'border-emerald-300 bg-emerald-50 ring-1 ring-emerald-200' : 'border-stone-200 bg-stone-50'}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2.5">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${mod.highlight ? 'bg-emerald-100 border border-emerald-200' : 'bg-white border border-stone-200'}`}>
                    <i className={`${mod.icon} text-sm w-4 h-4 flex items-center justify-center ${mod.highlight ? 'text-emerald-600' : 'text-stone-600'}`}></i>
                  </div>
                  <h4 className="text-stone-800 font-semibold text-sm">{mod.title}</h4>
                </div>
                <div className="flex items-center gap-2 ml-2">
                  {mod.highlight && (
                    <span className="px-2 py-0.5 rounded-full bg-emerald-200 text-emerald-800 text-xs font-bold">Destaque</span>
                  )}
                  <span className="text-xs text-stone-400 whitespace-nowrap">{mod.phase}</span>
                </div>
              </div>
              <ul className="space-y-2">
                {mod.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2">
                    <div className="w-3 h-3 mt-0.5 flex items-center justify-center flex-shrink-0">
                      <div className="w-1.5 h-1.5 rounded-full bg-emerald-500"></div>
                    </div>
                    <span className="text-stone-500 text-xs leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ===== AGENTE ANALISADOR — DETALHAMENTO TÉCNICO ===== */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-7 h-7 rounded-lg bg-emerald-100 flex items-center justify-center">
              <i className="ri-brain-line text-emerald-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-stone-900">Como o Agente Analisador é Construído e o que ele faz</h3>
          </div>

          {/* Arquitetura do Analisador */}
          <div className="p-6 rounded-2xl border border-stone-200 bg-stone-50 mb-6">
            <h4 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-cpu-line text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              Arquitetura do Agente Analisador
            </h4>
            <p className="text-stone-500 text-xs leading-relaxed mb-5">
              O Agente Analisador não lê o edital de uma vez — ele opera em camadas especializadas, cada uma responsável por extrair um tipo específico de informação. Isso garante precisão mesmo em editais com centenas de páginas, linguagem técnica densa e estruturas não padronizadas.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                {
                  icon: 'ri-file-search-line',
                  title: 'Agente de Segmentação',
                  desc: 'Divide o edital em blocos temáticos antes da análise: seção de elegibilidade, seção de orçamento, seção de cronograma, etc. Isso permite que cada agente especializado receba apenas o trecho relevante.',
                  color: 'border-stone-300 bg-white',
                  iconColor: 'text-stone-600',
                },
                {
                  icon: 'ri-list-check-3',
                  title: 'Agentes Extratores por Categoria',
                  desc: 'Oito agentes especializados, um para cada categoria: elegibilidade, escopo técnico, orçamento permitido, perfil de equipe, critérios de avaliação, prazos, documentos obrigatórios e restrições.',
                  color: 'border-stone-300 bg-white',
                  iconColor: 'text-stone-600',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'Agente Validador de Consistência',
                  desc: 'Após a extração, verifica se os dados extraídos são coerentes entre si — por exemplo, se o prazo de submissão é posterior à data de publicação e se o valor máximo é compatível com as rubricas permitidas.',
                  color: 'border-emerald-200 bg-emerald-50',
                  iconColor: 'text-emerald-600',
                },
                {
                  icon: 'ri-alarm-warning-line',
                  title: 'Agente de Alertas e Prazos',
                  desc: 'Monitora continuamente os prazos extraídos e dispara notificações automáticas nos marcos D-30, D-15, D-7 e D-1, com resumo do edital e link direto para a chamada no portal FINEP.',
                  color: 'border-emerald-200 bg-emerald-50',
                  iconColor: 'text-emerald-600',
                },
                {
                  icon: 'ri-refresh-line',
                  title: 'Agente de Reprocessamento',
                  desc: 'Detecta falhas de extração (campos vazios, dados inconsistentes ou baixa confiança) e aciona automaticamente um novo ciclo de análise com estratégia alternativa de leitura do documento.',
                  color: 'border-stone-300 bg-white',
                  iconColor: 'text-stone-600',
                },
                {
                  icon: 'ri-file-text-line',
                  title: 'Agente de Resumo Executivo',
                  desc: 'Ao final da análise, gera um resumo em linguagem clara e objetiva com os pontos mais relevantes do edital para o gestor: o que é financiado, quem pode participar, quanto pode ser solicitado e quando submeter.',
                  color: 'border-stone-300 bg-white',
                  iconColor: 'text-stone-600',
                },
              ].map((a) => (
                <div key={a.title} className={`p-4 rounded-xl border ${a.color}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-7 h-7 rounded-lg bg-stone-100 flex items-center justify-center">
                      <i className={`${a.icon} ${a.iconColor} text-sm w-4 h-4 flex items-center justify-center`}></i>
                    </div>
                    <p className="text-stone-800 text-xs font-semibold">{a.title}</p>
                  </div>
                  <p className="text-stone-500 text-xs leading-relaxed">{a.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* As 8 categorias extraídas */}
          <div className="p-6 rounded-2xl border border-stone-200 bg-white mb-6">
            <h4 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-list-check-3 text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              As 8 Categorias Extraídas Automaticamente de Cada Edital
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { num: '01', title: 'Elegibilidade', desc: 'Quem pode participar: tipo de instituição, porte, localização, área de atuação, histórico de inadimplência e restrições específicas da chamada' },
                { num: '02', title: 'Escopo Técnico', desc: 'O que pode ser financiado: áreas temáticas, linhas de pesquisa, nível de maturidade tecnológica (TRL) exigido e restrições de objeto' },
                { num: '03', title: 'Orçamento Permitido', desc: 'Valor mínimo e máximo da chamada, rubricas elegíveis, percentuais máximos por categoria de despesa e contrapartida exigida' },
                { num: '04', title: 'Perfil de Equipe', desc: 'Titulação mínima do coordenador, número de pesquisadores exigido, vínculo institucional necessário e restrições de acúmulo de bolsas' },
                { num: '05', title: 'Critérios de Avaliação', desc: 'Pesos e critérios usados pela banca avaliadora: mérito científico, relevância tecnológica, capacidade de execução, impacto social e potencial de inovação' },
                { num: '06', title: 'Prazos e Cronograma', desc: 'Data de abertura, prazo de submissão, período de análise, data de resultado e prazo máximo de execução do projeto financiado' },
                { num: '07', title: 'Documentos Obrigatórios', desc: 'Lista completa de anexos exigidos: formulários, declarações, currículos, plano de trabalho, orçamento detalhado e documentos institucionais' },
                { num: '08', title: 'Restrições e Vedações', desc: 'O que não pode ser financiado, projetos em andamento que impedem a participação, conflitos de interesse e limitações geográficas ou setoriais' },
              ].map((s) => (
                <div key={s.num} className="flex items-start gap-3 p-3 rounded-lg bg-stone-50 border border-stone-200">
                  <span className="w-7 h-7 rounded-lg bg-stone-900 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{s.num}</span>
                  <div>
                    <p className="text-stone-700 text-xs font-semibold mb-0.5">{s.title}</p>
                    <p className="text-stone-400 text-xs leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Ciclo de análise */}
          <div className="p-6 rounded-2xl border border-stone-200 bg-stone-50 mb-6">
            <h4 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-loop-left-line text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              Ciclo de Análise com Validação Automática
            </h4>
            <div className="flex flex-wrap items-start gap-2">
              {[
                { step: '1', label: 'Edital detectado', sub: 'Novo PDF na fila de processamento' },
                null,
                { step: '2', label: 'Segmentação', sub: 'Divisão em blocos temáticos' },
                null,
                { step: '3', label: 'Extração paralela', sub: '8 agentes em simultâneo' },
                null,
                { step: '4', label: 'Validação', sub: 'Consistência entre campos' },
                null,
                { step: '5', label: 'Confiança ≥ 80%?', sub: 'Aprovado → resumo gerado' },
                null,
                { step: '6', label: 'Confiança &lt; 80%', sub: 'Reprocessamento automático' },
                null,
                { step: '7', label: 'Notificação', sub: 'Alerta enviado ao gestor' },
              ].map((s, i) =>
                s === null ? (
                  <span key={i} className="text-stone-300 text-lg font-light self-center">→</span>
                ) : (
                  <div key={i} className="flex flex-col items-center gap-1 px-3 py-2.5 rounded-lg border border-stone-200 bg-white text-center min-w-[90px]">
                    <span className="w-5 h-5 rounded-full bg-stone-900 text-white flex items-center justify-center text-xs font-bold">{s.step}</span>
                    <span className="text-stone-700 text-xs font-semibold leading-tight">{s.label}</span>
                    <span className="text-stone-400 text-xs leading-tight">{s.sub}</span>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Destaque analisador */}
          <div className="p-5 rounded-xl border border-stone-200 bg-stone-900 flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-stone-700 flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-emerald-400 text-base w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-sm mb-1">O Agente Analisador transforma centenas de páginas em decisões em minutos</p>
              <p className="text-stone-400 text-xs leading-relaxed">
                Um edital FINEP pode ter 80 a 300 páginas de texto técnico-jurídico. O Agente Analisador processa esse volume em minutos, extrai as 8 categorias críticas com alta precisão e entrega ao gestor um resumo executivo pronto para tomada de decisão — sem que nenhum analista precise ler o documento completo antes de decidir se vale a pena candidatar.
              </p>
            </div>
          </div>
        </div>

        {/* ===== AGENTE ESCRITOR — DETALHAMENTO TÉCNICO ===== */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-7 h-7 rounded-lg bg-emerald-100 flex items-center justify-center">
              <i className="ri-quill-pen-line text-emerald-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-stone-900">O que o Agente Escritor faz</h3>
          </div>

          {/* Capacidades do Agente Escritor */}
          <div className="p-6 rounded-2xl border border-stone-200 bg-stone-50 mb-6">
            <h4 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-magic-line text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              O que o Agente Escritor entrega
            </h4>
            <p className="text-stone-500 text-xs leading-relaxed mb-5">
              O Agente Escritor transforma os dados do edital e do projeto do instituto em uma proposta completa, técnica e aderente aos critérios FINEP — sem que o pesquisador precise escrever do zero. Abaixo estão as capacidades funcionais do agente:
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                {
                  icon: 'ri-file-add-line',
                  title: 'Geração completa da proposta',
                  desc: 'Produz automaticamente todas as 10 seções obrigatórias de uma proposta FINEP, do resumo executivo ao plano de disseminação, com linguagem técnica e objetiva adequada ao padrão da agência.',
                },
                {
                  icon: 'ri-search-eye-line',
                  title: 'Consulta à base de conhecimento em tempo real',
                  desc: 'Durante a escrita, o agente busca automaticamente trechos de propostas aprovadas anteriormente, normas FINEP vigentes e glossários técnicos para embasar cada seção gerada.',
                },
                {
                  icon: 'ri-refresh-line',
                  title: 'Reescrita automática por qualidade',
                  desc: 'Cada seção gerada passa por avaliação interna. Se o texto não atingir o padrão mínimo de qualidade definido pelos critérios do edital, o agente reescreve automaticamente até aprovação.',
                },
                {
                  icon: 'ri-translate-2',
                  title: 'Adequação ao vocabulário do edital',
                  desc: 'O agente identifica os termos, critérios e linguagem específicos de cada chamada e adapta o texto gerado para maximizar a aderência ao que os avaliadores esperam ler.',
                },
                {
                  icon: 'ri-merge-cells-horizontal',
                  title: 'Coerência entre todas as seções',
                  desc: 'Ao final da geração, o agente verifica se os dados são consistentes em toda a proposta — valores, datas, nomes de pesquisadores e metas não se contradizem entre seções diferentes.',
                },
                {
                  icon: 'ri-eye-line',
                  title: 'Visualização em tempo real',
                  desc: 'O pesquisador acompanha o texto sendo gerado seção por seção diretamente no navegador, podendo intervir, ajustar ou solicitar reescrita de qualquer parte antes de finalizar.',
                },
                {
                  icon: 'ri-history-line',
                  title: 'Versionamento de rascunhos',
                  desc: 'Cada versão gerada é salva automaticamente. O pesquisador pode comparar rascunhos, restaurar versões anteriores e manter um histórico completo de todas as iterações da proposta.',
                },
                {
                  icon: 'ri-user-voice-line',
                  title: 'Calibração com o setor de editais',
                  desc: 'O agente é ajustado em conjunto com os analistas do instituto, incorporando o estilo de escrita aprovado pela FINEP, os critérios mais valorizados e os erros históricos de propostas reprovadas.',
                },
              ].map((a) => (
                <div key={a.title} className="p-4 rounded-xl border border-stone-200 bg-white flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-stone-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${a.icon} text-stone-600 text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <p className="text-stone-800 text-xs font-semibold mb-1">{a.title}</p>
                    <p className="text-stone-400 text-xs leading-relaxed">{a.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Seções geradas */}
          <div className="p-6 rounded-2xl border border-stone-200 bg-white mb-6">
            <h4 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
              <i className="ri-file-list-3-line text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              As 10 Seções Geradas Automaticamente
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { num: '01', title: 'Identificação e Resumo Executivo', desc: 'Título, área temática, valor solicitado, duração e síntese do projeto em linguagem alinhada ao edital' },
                { num: '02', title: 'Caracterização do Problema', desc: 'Diagnóstico do problema de pesquisa com referências ao contexto nacional e regional, justificando a relevância' },
                { num: '03', title: 'Objetivos Geral e Específicos', desc: 'Objetivos redigidos com verbos de ação mensuráveis, alinhados aos critérios de avaliação do edital' },
                { num: '04', title: 'Metodologia e Plano de Trabalho', desc: 'Descrição das etapas metodológicas, abordagem científica e justificativa das escolhas técnicas' },
                { num: '05', title: 'Cronograma de Execução', desc: 'Tabela de atividades por mês com marcos, responsáveis e dependências entre tarefas' },
                { num: '06', title: 'Equipe Executora', desc: 'Perfis dos pesquisadores com titulação, experiência e papel no projeto, adequados ao exigido pelo edital' },
                { num: '07', title: 'Plano de Aplicação de Recursos', desc: 'Rubricas orçamentárias detalhadas com justificativa de cada item e aderência às normas FINEP' },
                { num: '08', title: 'Resultados Esperados e Indicadores', desc: 'Metas quantificáveis, indicadores de desempenho e produtos esperados ao final de cada etapa' },
                { num: '09', title: 'Impacto Científico, Tecnológico e Social', desc: 'Argumentação sobre o potencial de inovação, transferência de tecnologia e benefícios para a sociedade' },
                { num: '10', title: 'Propriedade Intelectual e Disseminação', desc: 'Estratégia de proteção de resultados, publicações previstas e plano de transferência de tecnologia' },
              ].map((s) => (
                <div key={s.num} className="flex items-start gap-3 p-3 rounded-lg bg-stone-50 border border-stone-200">
                  <span className="w-7 h-7 rounded-lg bg-stone-900 text-white text-xs font-bold flex items-center justify-center flex-shrink-0">{s.num}</span>
                  <div>
                    <p className="text-stone-700 text-xs font-semibold mb-0.5">{s.title}</p>
                    <p className="text-stone-400 text-xs leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ===== COLABORAÇÃO COM O SETOR DE EDITAIS ===== */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-7 h-7 rounded-lg bg-amber-100 flex items-center justify-center">
              <i className="ri-team-line text-amber-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-stone-900">Colaboração com o Setor de Editais do Instituto</h3>
          </div>

          <div className="p-5 rounded-xl border border-amber-200 bg-amber-50 mb-6">
            <p className="text-stone-600 text-sm leading-relaxed">
              O Agente Escritor não nasce pronto — ele é <strong className="text-stone-800">calibrado e refinado em conjunto com a equipe de captação do instituto</strong>. O conhecimento acumulado pelos analistas sobre o estilo de escrita aprovado pela FINEP, os critérios que mais pesam na avaliação e os erros históricos de propostas reprovadas é o insumo mais valioso para treinar o agente.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {[
              {
                fase: 'Fase de Onboarding (Semana 1 a 2)',
                icon: 'ri-survey-line',
                color: 'border-stone-200 bg-white',
                badgeColor: 'bg-stone-100 text-stone-600',
                steps: [
                  { label: 'Entrevistas com analistas', desc: 'Sessões estruturadas com os especialistas do setor de editais para mapear o processo atual de escrita de propostas, os critérios mais valorizados e os erros mais comuns' },
                  { label: 'Coleta de propostas históricas', desc: 'Levantamento de propostas aprovadas e reprovadas do instituto para alimentar a base de conhecimento do agente com exemplos reais e contextualizados' },
                  { label: 'Mapeamento de vocabulário institucional', desc: 'Identificação de termos, siglas e expressões específicas do instituto que devem ser incorporados ao estilo de escrita do agente' },
                ],
              },
              {
                fase: 'Fase de Calibração (Mês 3)',
                icon: 'ri-equalizer-line',
                color: 'border-amber-200 bg-amber-50',
                badgeColor: 'bg-amber-100 text-amber-700',
                steps: [
                  { label: 'Sessões de avaliação de rascunhos', desc: 'Os analistas do instituto avaliam os primeiros rascunhos gerados pelo agente, apontando o que está correto, o que precisa de ajuste e o que está fora do padrão esperado' },
                  { label: 'Ajuste fino dos prompts', desc: 'Com base no feedback dos analistas, a equipe técnica refina os agentes para incorporar as preferências e o estilo aprovado pelo instituto' },
                  { label: 'Validação com edital real', desc: 'O agente é testado com um edital FINEP real e o resultado é avaliado lado a lado com uma proposta escrita manualmente pelo setor, medindo a diferença de qualidade' },
                ],
              },
              {
                fase: 'Fase de Testes Finais (Mês 4)',
                icon: 'ri-test-tube-line',
                color: 'border-stone-200 bg-white',
                badgeColor: 'bg-stone-100 text-stone-600',
                steps: [
                  { label: 'Ciclo de revisão colaborativa', desc: 'O setor de editais revisa as propostas geradas pelo agente como se fossem propostas reais, e o feedback é incorporado como ajuste final antes do go-live' },
                  { label: 'Definição do fluxo de aprovação', desc: 'Em conjunto com o instituto, é definido o fluxo de revisão humana: quais seções exigem aprovação obrigatória antes da exportação e quais podem ser exportadas diretamente' },
                  { label: 'Treinamento da equipe operacional', desc: 'Os analistas aprendem a usar o editor integrado para revisar, ajustar e aprovar as propostas geradas, tornando-se co-autores do processo e não apenas usuários passivos' },
                ],
              },
              {
                fase: 'Pós-Entrega — Melhoria Contínua',
                icon: 'ri-loop-right-line',
                color: 'border-emerald-200 bg-emerald-50',
                badgeColor: 'bg-emerald-100 text-emerald-700',
                steps: [
                  { label: 'Feedback loop de resultados', desc: 'Quando uma proposta gerada pelo agente é aprovada ou reprovada, o resultado é registrado na plataforma e usado para melhorar os critérios de avaliação do agente crítico' },
                  { label: 'Atualização da base de conhecimento', desc: 'Novas propostas aprovadas são automaticamente incorporadas à base de conhecimento, tornando o agente progressivamente mais preciso com o tempo' },
                  { label: 'Relatório mensal de qualidade', desc: 'A plataforma gera um relatório mensal mostrando a evolução do score médio das propostas geradas, o número de reescritas necessárias e a taxa de aprovação acumulada' },
                ],
              },
            ].map((fase) => (
              <div key={fase.fase} className={`rounded-xl border ${fase.color} overflow-hidden`}>
                <div className="px-4 py-3 border-b border-inherit flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg bg-white border border-stone-200 flex items-center justify-center">
                    <i className={`${fase.icon} text-stone-600 text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${fase.badgeColor}`}>{fase.fase}</span>
                </div>
                <div className="p-4 space-y-4">
                  {fase.steps.map((s) => (
                    <div key={s.label}>
                      <p className="text-stone-700 text-xs font-semibold mb-0.5 flex items-center gap-1.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0"></span>
                        {s.label}
                      </p>
                      <p className="text-stone-400 text-xs leading-relaxed pl-3">{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Destaque colaboração */}
          <div className="p-5 rounded-xl border border-stone-200 bg-stone-900 flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-stone-700 flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-amber-400 text-base w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-sm mb-1">O instituto não é apenas cliente — é co-desenvolvedor do agente</p>
              <p className="text-stone-400 text-xs leading-relaxed">
                A qualidade final do Agente Escritor depende diretamente do conhecimento que o setor de editais do instituto traz para o processo. Quanto mais propostas históricas, mais feedback nas sessões de calibração e mais contexto institucional for compartilhado, mais preciso e aderente ao padrão FINEP o agente se tornará. Esse é um diferencial que nenhuma solução genérica de mercado consegue replicar.
              </p>
            </div>
          </div>
        </div>

        {/* Fluxo visual */}
        <div className="p-6 rounded-2xl border border-emerald-200 bg-emerald-50">
          <h3 className="text-sm font-semibold text-stone-800 mb-4">Fluxo Completo — Do Edital à Submissão</h3>
          <div className="flex flex-wrap items-center gap-2">
            {[
              { step: '1', label: 'Edital publicado na FINEP' },
              null,
              { step: '2', label: 'Coleta e análise automática' },
              null,
              { step: '3', label: 'Matching com projetos do instituto' },
              null,
              { step: '4', label: 'Geração automática da proposta' },
              null,
              { step: '5', label: 'Checklist de conformidade' },
              null,
              { step: '6', label: 'Exportação e submissão na plataforma FINEP' },
            ].map((s, i) =>
              s === null ? (
                <span key={i} className="text-stone-400 text-lg font-light">→</span>
              ) : (
                <div key={i} className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-emerald-300 bg-emerald-100 text-emerald-800 text-xs font-medium">
                  <span className="w-4 h-4 rounded-full bg-white/60 flex items-center justify-center text-xs font-bold">{s.step}</span>
                  <span>{s.label}</span>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
